import { MapPin, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

const HOSPITALS = [
    {
        name: "Fortis Memorial Research Hospital",
        city: "Gurugram",
        accred: "JCI, NABH",
        beds: 500,
        img: "https://res.cloudinary.com/deq3rnrha/image/upload/v1776768074/fortis_fl17wj.jpg",
    },
    {
        name: "Medanta — The Medicity",
        city: "Gurugram",
        accred: "JCI, NABH",
        beds: 1000,
        img: "https://res.cloudinary.com/deq3rnrha/image/upload/v1776768074/medanta_wblhv3.jpg",
    },
    {
        name: "Artemis Hospital",
        city: "Gurugram",
        accred: "JCI, NABH",
        beds: 750,
        img: "https://res.cloudinary.com/deq3rnrha/image/upload/v1776768074/Artemis_uzmeif.jpg",
    },
    {
        name: "Max Super Speciality Hospital",
        city: "Saket, New Delhi",
        accred: "JCI, NABH",
        beds: 600,
        img: "https://res.cloudinary.com/deq3rnrha/image/upload/v1776768074/max_yhgduv.jpg",
    },
];

export const Hospitals = () => {
    const { t } = useTranslation();

    return (
        <section
            id="hospitals"
            data-testid="hospitals-section"
            className="relative py-20 md:py-28 bg-stone-900 text-stone-100"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="text-xs uppercase tracking-[0.2em] text-orange-400 font-semibold mb-3">
                            {t("hospitals.eyebrow")}
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-2xl leading-[1.05]">
                            {t("hospitals.title")}
                        </h2>
                    </div>
                    <p className="md:max-w-sm text-stone-400">
                        {t("hospitals.subtitle")}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {HOSPITALS.map((h) => (
                        <article
                            key={h.name}
                            data-testid={`hospital-card-${h.name.split(" ")[0].toLowerCase()}`}
                            className="group rounded-3xl overflow-hidden bg-stone-800/60 border border-white/5 hover:border-brand-400/50 transition-all flex flex-col"
                        >
                            <div className="relative aspect-[16/11] overflow-hidden">
                                <img
                                    src={h.img}
                                    alt={h.name}
                                    className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 to-transparent" />
                            </div>
                            <div className="p-5 flex-1 flex flex-col">
                                <h3 className="font-display text-lg font-bold leading-tight">
                                    {h.name}
                                </h3>
                                <div className="mt-2 flex items-center gap-2 text-sm text-stone-400">
                                    <MapPin className="h-4 w-4" />
                                    {h.city}
                                </div>
                                <div className="mt-4 flex flex-wrap gap-2">
                                    <span className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-brand-500/15 text-brand-300 border border-brand-400/20">
                                        <ShieldCheck className="h-3.5 w-3.5" />
                                        {h.accred}
                                    </span>
                                    <span className="text-xs px-2.5 py-1 rounded-full bg-white/5 text-stone-300 border border-white/10">
                                        {t("hospitals.beds", { count: h.beds })}
                                    </span>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
